var _defs, _tspan, _tspan2, _tspan3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamuelLamLogoForBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "50 140 500 200",
    width: 200,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsbx: "https://boxy-svg.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    bxfonts: "Encode Sans"
  }, "@import url(https://fonts.googleapis.com/css2?family=Encode+Sans%3Aital%2Cwght%400%2C100%3B0%2C200%3B0%2C300%3B0%2C400%3B0%2C500%3B0%2C600%3B0%2C700%3B0%2C800%3B0%2C900&amp;display=swap);"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.974018, 0, 0, 1.974018, -199.168005, -291.906106)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.373213, 0, 0, 0.365258, 121.256973, 192.178131)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(163, 31, 52)",
      stroke: "rgb(163, 31, 52)"
    },
    d: "M 74.89 299.496 L 185.304 214.145 C 173.534 269.894 126.262 298.894 74.89 299.496 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(207, 20, 43)",
      stroke: "rgb(207, 20, 43)"
    },
    d: "M 74.231 298.907 L 184.645 213.556 C 172.875 269.305 125.603 298.305 74.231 298.907 Z",
    transform: "matrix(-1, 0, 0, -1, 258.876007, 512.463013)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.328856, -0.189865, 0.188347, 0.326227, 67.999664, 217.848587)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(68, 164, 68)",
      fill: "rgb(68, 164, 68)"
    },
    d: "M 74.89 299.496 L 185.304 214.145 C 173.534 269.894 126.262 298.894 74.89 299.496 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(151, 198, 30)",
      stroke: "rgb(151, 198, 30)"
    },
    d: "M 74.231 298.907 L 184.645 213.556 C 172.875 269.305 125.603 298.305 74.231 298.907 Z",
    transform: "matrix(-1, 0, 0, -1, 258.876007, 512.463013)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189866, -0.328856, 0.326227, 0.188348, 36.88969, 269.39917)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 33, 71)",
      fill: "rgb(0, 33, 71)"
    },
    d: "M 74.89 299.496 L 185.304 214.145 C 173.534 269.894 126.262 298.894 74.89 299.496 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 62, 116)",
      stroke: "rgb(0, 62, 116)"
    },
    d: "M 74.231 298.907 L 184.645 213.556 C 172.875 269.305 125.603 298.305 74.231 298.907 Z",
    transform: "matrix(-1, 0, 0, -1, 258.876007, 512.463013)"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "&quot",
      fontSize: 20,
      fontWeight: 500,
      whiteSpace: "pre"
    },
    transform: "matrix(1.974018, 0, 0, 1.974018, -217.464621, -240.243263)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 205.297,
    y: 255.498
  }, "CHUN HEI")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 205.297,
    dy: "1em"
  }, "\u200B")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", null, "SAMUEL LAM"))), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "9.6px"
    },
    x: 275.439,
    y: 337.953
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamuelLamLogoForBlack);
export default __webpack_public_path__ + "static/media/Samuel_Lam_Logo_for_black.0152b9f991ceb97e3f735b5a9fd2212d.svg";
export { ForwardRef as ReactComponent };